import { Component, OnInit } from '@angular/core';
import { AngularFirestore } from '@angular/fire/firestore';
import { Blobs } from 'my-lib-sanfelici';




@Component({
  selector: 'app-marchi-list-pdf',
  templateUrl: './marchi-list-pdf.component.html',
  styleUrls: ['./marchi-list-pdf.component.scss']
})
export class MarchiListPdfComponent implements OnInit {

  constructor(private db: AngularFirestore) { }

  ngOnInit() {
const d= this.db.collectionGroup<Blobs>('blobs',ref=>ref.where('type','==','marchi'))
.valueChanges();

  }

}
